import React, {useState, useEffect} from 'react'
import {LoadEffect}  from '../component/loader'
import axios from 'axios'
import { Alerts, WarningModal } from '../../component/notify'
import PageHeader from '../component/pageheader'
import {ImagesUrl,  ServerUrl,  Token, config, API_URL, sectionID, classID} from '../../component/include'

import { useSelector } from 'react-redux'
import Select from 'react-select'
import { getClassName, longDate} from '../component/globalFunction'

const DisplayStudentAttendance =()=> {
    const [errors, setErrors] = useState({});
    const [result, setResult] = useState([])
    const [sqlQuery, setSqlQuery] = useState([]);
    const [schoolInfo, setSchoolInfo]=useState([])
    const [notice, setNotice] = useState({
        isLoading : false, 
        isDataFetching: false,
    }); 
    
const schoolClass  = useSelector(state => state.rootReducer.schoolClass);
    const [head, setHead]= useState([])
    const [attendance, setAttendance] = useState({
       staff:[],
       sectionID:[],
        subject:[],
        attendanceType:'fullday',
        attendanceMonth:'',
        orderBy:{value:'order by s.studentName ASC', label:'order by Name'},
    })

    const fetchSchoolInfo =()=>{
        const fd = new FormData();
        fd.append('jwt', Token); 
        let url = ServerUrl + '/fetch_controller/tbl_basic_details'
        axios.post(url, fd, config).then(result=>setSchoolInfo(result.data))

    }


       
     
    
        const handleSelect= (option, action)=>{

            setAttendance({...attendance, [action.name]:option});
            setErrors({...errors, [action.name]:''})
            setResult('')
        }

        const handleChange=(event)=>{
            const {name, value} = event.target;
            setAttendance({...attendance, [name]:value})

            if(name==='attendanceMonth'){
            const days =  new Date(value.slice(0,4), value.slice(5,7), 0).getDate();
            const start = value+'-01';
            const end = value+'-'+days;
            getDaysBetween(start, end)
            }
            setResult('')
            setErrors({...errors, [name]:''})
        }
       
        const getDaysBetween =(startDate, endDate)=>{
            const start = new Date(startDate)
            const end =  new Date(endDate)
        
            var result = []
            while (start <= end){
                result.push(new Date(start).toISOString().slice(0,10))
                start.setDate(start.getDate()+1)
            }
    
            let sqlString = result.map(data=>"max(case when a.attendanceDate  = '"+data+"'  then a.indicator else '-' end) AS '"+data.slice(8,10)+getDays(data)+"'")
            setHead(result.map(data=>data.slice(8,10)+getDays(data)))
    
       

            let final =   'SELECT  s.admissionNumber, s.studentName, s.sectionID, sum(case when a.indicator  = "P" then 2 else 0 end) as P, sum(case when a.indicator  = "H" then 1 else 0 end) as H, sum(case when a.indicator  = "A" then 2 else 0 end) as A, '+String(sqlString)+ ' from tbl_students s, tbl_student_attendance a where   s.code = a.studentCode and s.sectionID = "'+sectionID+'" and a.attendanceDate >= "'+startDate+'" and a.attendanceDate <= "'+endDate+'"'


            setSqlQuery(final)
        }
        
        const getDays=(date)=>{
            let day;
            switch (new Date(date).getDay()){
                case 0:
                    day =" Sun";
                    break;
                case 1:
                    day =" Mon";
                    break;
                case 2:
                    day =" Tue";
                   break;
                case 3:
                    day =" Wed";
                        break;
                case 4:
                    day =" Thu";
                        break;
                case 5:
                    day =" Fri";
                    break;
                case 6:
                    day =" Sat"
                    break;
                default:
                    day=" Sun"
            }
                return day
            }
    
            const fetchResult =()=>{
                if(attendance.attendanceMonth===''){
                    setErrors({...errors, attendanceMonth:'Please select attendnace month'})
                } else{
                
                
                    var sql = sqlQuery


            sql = sql+ ' group by a.studentCode '+attendance.orderBy.value
            if(sectionID !==undefined && sectionID !==''){
            
  setNotice({...notice, isLoading: true}) 
            const fd = new FormData();
            fd.append("sql", sql);
           let url = API_URL+'/exam/result/fetch_raw';
            axios.post(url, fd, config).then(result=>{
                if(result.data.data.length!==0){
                    setResult(result.data.data)
                }else{
                    Alerts('Info!', 'default', 'No record found for the selected criterials')
                }
                
            })
            .catch((error)=>{
            Alerts('Error!', 'danger', error.message)
            }).finally(()=>{
                setNotice({...notice, isLoading: false})
                
            })  
        } }
            }
    
     
     useEffect(()=>{
        fetchSchoolInfo()
    },[]);


        return (  
            <React.Fragment>
   <>{notice.isLoading ?<LoadEffect className="overlay floatLoad" /> : "" }
   <div  className="main-body">
                <div className="page-wrapper">
                 
                   {/* <!-- Page-header start --> */}

        <PageHeader title="Search  Attendance">
        <li className="breadcrumb-item"><a  href="#!"> <i className="fa fa-fw fa-calendar"></i> </a>
                            </li>
                            <li className="breadcrumb-item"><a href="#!">Attendance</a> </li>
                    <li className="breadcrumb-item"><a href="#!">Student Attendance</a> </li>
                    </PageHeader>
{/* The Page Body start here */}
                <div className="page-body">

                <div className="row  ">
						
                        <div className="col-sm-12">
                    
                        <div className="card z-depth-0">
                            <div className="card-header">
                                <h5><i className="fa fa-edit" ></i> Display Student Attendance</h5>
                                <div className="card-header-right">
                                    <ul className="list-unstyled card-option">
                                        <li><i className="feather icon-maximizes full-card"></i></li>
                                        <li><i className="feather icon-minus minimize-card"></i></li>
                                        <li><i className="feather icon-trash-2 close-card"></i></li>
                                    </ul>
                                </div>
                            </div>
                            
                            
                            <div className="card-block">
            
        <section className="col-md-12">
        <span className="pcoded-badge label bg-simple-c-pink">Color Icon For Absent</span>
        
        <span className="pcoded-badge label label-info">Color Icon For Half Day</span>
        <span className="pcoded-badge label bg-simple-c-green">Color Icon For Present</span>
        </section>


        <div  className="card-block">
        <div  className="card z-depth-0" >

		<div  className="card-block">
		
        <div className="row">
        
      
      <section className="col-md-6">
      <div className="form-group">
   <label >Select Attendance Month</label>
   <input type="month" className={errors.attendanceMonth ? 'form-control form-control-danger' : 'form-control'} name="attendanceMonth"   onChange={handleChange} value={attendance.attendanceMonth} />

   <span style={{color:'red'}}>{errors.attendanceMonth && errors.attendanceMonth}</span>
               </div>

   

</section>

<section className="col-md-6">
            <div className="form-group">
          <label> Order</label>
          <Select  options={[
             {value:'order by s.studentName ASC', label:'order by Name'},
                    { value: 'order by s.registerNumber ASC', label: 'Order By Register Number'},
             { value: 'order by s.admissionNumber ASC', label: 'Order By Admission Number'},
                ]} 
onChange={handleSelect}  name="orderBy" value={attendance.orderBy}  /> 

 
             </div>
      
      </section>
      

				</div>	

<div className="row" >
<section className="col-md-12">
	<footer className="pull-right">
	
	<button type="button" id="submit" onClick={fetchResult} className="btn btn-primary "><i className="fa fa-search"></i> Search Attendance</button>
								</footer>		</section>		
                                </div>
                            
                            
                            </div></div> 
							</div></div>
</div>
</div>
</div>



{result.length!==0?
    <div className="card z-depth-0">
		<div className="card-block">
	
         {schoolInfo&&schoolInfo.map((st, id)=>
                             <div className="col-md-12" key={id}>
      
      <table className="table  table-full-width">
             <tbody>
             <tr>
             <td className="text-center" ><img id="viewSchoolLogo2" className="img-100" onError={(e)=>{e.target.onerror = null; e.target.src=ImagesUrl+'/logo.png'}} src={`${ImagesUrl}/about/${st.schoolLogo}`}  title="School Logo" alt=''  />
      <h4 style={{textAlign:'center'}}><b>{st.schoolName}</b></h4>
      <h6 style={{textAlign:'center'}}><b>Motto: {st.schoolMotto}</b></h6>
      <div style={{textAlign:'center'}}>  {st.address}  </div>
      <div style={{textAlign:'center'}}> {st.mobile}, {st.altMobile}, {st.email} </div>
      
      <div style={{textAlign:'center'}}>  Website: {st.website}  </div>
       </td>
                      </tr>
                  </tbody>
             </table>
      
      </div> 
                             )}
 <div className="row">
        <div className="col-md-12">
        <h5 style={{textAlign:'center'}}><u><b>Student Attendance </b></u></h5>
        </div></div><br/>



<div className="row">
<div className="col-md-12 table-responsive">

       <table className="table table-bordered  table-full-width">
       <tbody>
                <tr>
                    <td >Class: <b>{getClassName(classID, sectionID, schoolClass)}</b></td>
                    <td >Month: <b>{attendance.attendanceMonth}</b></td>
                    <td>Date Printed: <b>{longDate(new Date())} </b></td>
                </tr>
            </tbody>
       </table>
       <table className="table table-striped table-bordered">
        <thead>
                <tr>
                <th>S/N</th>
                <th>Admission No</th>
                    <th>Student Name</th>
                    <th>P</th>
                    <th>H</th>
                    <th>A</th>
                     {head&&head.map((data, id)=><th key={id} >{data}</th>)} 
                </tr>
              </thead>
              <tbody>
              {result.length!==0?result.map((st, idx)=> 
                <tr key={idx}>
                <td>{idx+1}</td>
                <td>{st.admissionNumber}</td>
                    <td>{st.studentName}</td>
                <td>{st.P}</td>
                <td>{st.H}</td> 
                    <td>{st.A}</td>            
                    {head&&head.map((data, id)=><td key={id} >
                    {st[data]==='P'?
                    <span className="pcoded-badge label label-success">{st[data]}</span>:
                    st[data]==='A'?
                    <span className="pcoded-badge label label-danger">{st[data]}</span>: 
                    st[data]==='H'?
                    <span className="pcoded-badge label label-info">{st[data]}</span>:
                    st[data]} </td>)} 
                </tr>):[]}
              </tbody>

        </table>
 </div>	 </div> 

 </div>
        </div>:''}



   </div>
          {/* The Page Body close here */}

            </div>
            </div>

</> 
</React.Fragment>
 );
        
}

export default React.memo(DisplayStudentAttendance) 